export const config={
    api:"https://pixel-stream-backend.vercel.app"
    // api:"https://pixel-stream.herokuapp.com"
    // api:"http://localhost:5000"
}